import { render, staticRenderFns } from "./message-item.vue?vue&type=template&id=1eb9115e&scoped=true"
import script from "./message-item.vue?vue&type=script&lang=js"
export * from "./message-item.vue?vue&type=script&lang=js"
import style0 from "./message-item.vue?vue&type=style&index=0&id=1eb9115e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb9115e",
  null
  
)

export default component.exports